//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { getChatroomMessage } from '~/api/index';
import { formatMsg } from '~/utils';

export default {
  data() {
    return {
      messages: [],
      timeInterval: null,
      onlineUserCount: 0,
      host: {
        name: '',
        tag: '',
      },
      route: '',
      show: false,
    };
  },

  computed: {
    ...mapGetters('user', ['vipMemberInfo']),
    /**
     * @description 判断是否为会员
     */
    isMember() {
      const nowtime = new Date().getTime();
      return (
        this.vipMemberInfo &&
        nowtime < this.vipMemberInfo.expireTimestamp * 1000
      );
    },
    initOption() {
      return {
        hoverStop: true, // 鼠标移入时是否停止滚动
        singleHeight: 0,
        waitTime: 0,
        step: 0.5, // 滚动速度，越大越快
        autoPlay: true,
      };
    },
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  mounted() {
    this.getMessage();
    this.timeInterval = setInterval(() => {
      this.getMessage();
    }, 10000);
  },
  methods: {
    async getMessage() {
      const res = await this.$axios(getChatroomMessage(1));
      const result = (res && res.result) || null;
      if (result) {
        this.host = result.host;
        this.messages = result.messages;
        this.onlineUserCount = result.onlineUserCount;
        this.route = result.route;
        this.show = true;
      } else {
        this.show = false;
      }
    },
    goChatroom() {
      window.open(this.route);
    },
    formatMsg(str) {
      return formatMsg(str);
    },
  },
};
